module.exports = __webpack_public_path__ + "img/kehu_3@2x.20435022.png";